/**
 * feature-config flag names owned by cms-authoring
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const CMS_AUTHORING_FLAG_NAMES = {
  CMS_AI_QUICK_MODIFICATIONS:
    'ff-cmsauth-3236-ai-field-content-generation-quick-mods',
  CMS_ITEM_CACHE_INVAlIDATION: 'ff-cmsauth-2735-cms-item-cache-invalidation',
  RICH_TEXT_COPY_PASTE_ANALYTICS:
    'ff-cmsauth-2348-rich-text-copy-paste-analytics',
  RICH_TEXT_IMAGE_REPLACEMENT: 'ff-pq-1807-rich-text-image-replacement',
  CMS_LIBRARY_COMPONENTS_IN_RICH_TEXT:
    'ff-cont-6022-shared-library-components-in-rt',
  CMS_DM_CANVAS_INTEGRATION: 'ff-cmsauth-4573-dm-canvas-integration',
  CMS_INDEXING_BULK_ACTIONS: 'ff-aeo-112-cms-indexing-bulk-actions',
  RTF_VERSION_WRAP_WRITE: 'ff-cmsauth-5353-rtf-version-wrap-write',
  RESTRICT_STALE_CLIENT: 'ff-cmsauth-5412-restrict-stale-client',
  CMS_COMPONENT_USAGES_RECONCILIATION:
    'ff-cmsauth-6030-component-usages-reconciliation',
  CMS_COMPONENT_USAGES_RECONCILIATION_AUTO_DELETE:
    'ff-cmsauth-6030-component-usages-reconciliation-auto-delete',
  CMS_RT_RESOLVE_LIBRARY_COMPONENTS:
    'ff-cont-6254-rt-resolve-library-components',
};
